{
  "v4.documents2.annuler": "Cancel",
  "v4.documents2.aucun_resultat_filtre": "No result for this filter.",
  "v4.documents2.code.AI_KILL_SWITCH_ACTIVE": "AI is stopped: retry once it is restored.",
  "v4.documents2.code.AMONT_PORTE_DEJA_DECIDEE": "This gate is already decided.",
  "v4.documents2.code.AMONT_PRODUCTION_INCONNUE": "This production is not defined by the project model.",
  "v4.documents2.code.AMONT_SOURCE_NON_APPROUVEE": "The source must be an approved version.",
  "v4.documents2.code.CORE_UNAVAILABLE": "AI is stopped: retry once it is restored.",
  "v4.documents2.code.CREATEUR_N_APPROUVE_PAS": "The author does not decide on their own request.",
  "v4.documents2.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v4.documents2.code.NOT_FOUND": "Object not found.",
  "v4.documents2.code.SOD_VIOLATION": "The run creator does not decide on their gate.",
  "v4.documents2.code.SPEC_CHANGE_SELF_DECISION": "The author does not decide on their own request.",
  "v4.documents2.code.VALIDATION_ERROR": "Input rejected by the server.",
  "v4.documents2.code.VALIDATION_PAR_UN_TIERS": "Another person must validate.",
  "v4.documents2.code.VERSION_CONFLICT": "The object changed since you read it: reload it.",
  "v4.documents2.code.WAIVER_DUPLICATE": "A waiver is already open on this criterion.",
  "v4.documents2.code_historique": "Legacy code: {{code}}",
  "v4.documents2.couverture": "Coverage",
  "v4.documents2.derogation.aucune_decision_locale": "The request goes to the decision workflow: nothing is decided here.",
  "v4.documents2.derogation.choisir_porteur": "Choose a member",
  "v4.documents2.derogation.cible": "Waiver target",
  "v4.documents2.derogation.cible_hors_projet": "This target does not belong to the project.",
  "v4.documents2.derogation.cible_test_usage": "Usability test {{cible}}",
  "v4.documents2.derogation.demande": "Request",
  "v4.documents2.derogation.echeance": "Expiry",
  "v4.documents2.derogation.echeance_future": "The expiry must be in the future.",
  "v4.documents2.derogation.echeance_requise": "An expiry is required for a criterion.",
  "v4.documents2.derogation.echec": "Sending failed.",
  "v4.documents2.derogation.enonce": "Statement",
  "v4.documents2.derogation.envoyee": "Request sent (waiver {{id}}).",
  "v4.documents2.derogation.envoyer": "Send the request",
  "v4.documents2.derogation.justification": "Justification",
  "v4.documents2.derogation.justification_aide": "Explain why the criterion cannot be met (at least 20 characters).",
  "v4.documents2.derogation.mesures": "Compensating controls (one per line)",
  "v4.documents2.derogation.mesures_requises": "At least one testable control is required.",
  "v4.documents2.derogation.minimum": "At least 20 characters.",
  "v4.documents2.derogation.nature": "Kind",
  "v4.documents2.derogation.nature_critere": "Criterion",
  "v4.documents2.derogation.nature_incompatible": "This target kind cannot be waived.",
  "v4.documents2.derogation.niveau": "Impact level",
  "v4.documents2.derogation.niveau_high": "High",
  "v4.documents2.derogation.niveau_low": "Low",
  "v4.documents2.derogation.niveau_medium": "Medium",
  "v4.documents2.derogation.origine": "Origin: {{origine}}",
  "v4.documents2.derogation.ouvrir": "Open the waiver",
  "v4.documents2.derogation.porteur": "Waiver owner",
  "v4.documents2.derogation.porteur_requis": "Choose the owner.",
  "v4.documents2.derogation.reference": "Reference",
  "v4.documents2.derogation.reference_version": "{{code}} (version {{version}})",
  "v4.documents2.derogation.titre": "Request a waiver",
  "v4.documents2.derogation.usage_indisponible": "A usability test waiver awaits its organisation workflow decision.",
  "v4.documents2.ecran_non_realise": "“{{ecran}}”: this screen is not built yet.",
  "v4.documents2.etat.chargement": "Loading: {{quoi}}…",
  "v4.documents2.etat.en_cours": "In progress…",
  "v4.documents2.etat.erreur": "Could not read: {{quoi}}.",
  "v4.documents2.etat.introuvable": "Not found: {{quoi}}.",
  "v4.documents2.etat.reessayer": "Retry",
  "v4.documents2.etat.refus": "Access denied: {{quoi}}.",
  "v4.documents2.etat.vide": "Nothing to show.",
  "v4.documents2.etat_document.approuve": "Approved",
  "v4.documents2.etat_document.brouillon": "Draft",
  "v4.documents2.etat_document.en_relecture": "In review",
  "v4.documents2.etat_document.publication_en_attente": "Publication pending",
  "v4.documents2.etat_document.publication_en_echec": "Publication failed",
  "v4.documents2.etat_document.publie": "Published",
  "v4.documents2.etat_document.refuse": "Rejected",
  "v4.documents2.etat_document.remplace": "Superseded",
  "v4.documents2.feuille.aujourd_hui": "Today: {{date}}",
  "v4.documents2.feuille.avancement": "Progress: {{avancement}}",
  "v4.documents2.feuille.echeance_depassee": "Overdue since {{date}}",
  "v4.documents2.feuille.echeance_non_datee": "Undated",
  "v4.documents2.feuille.echeance_prevue": "Planned on {{date}}",
  "v4.documents2.feuille.elements_termines": "{{n}} of {{total}} item(s) done",
  "v4.documents2.feuille.entree": "Input",
  "v4.documents2.feuille.etat_a_venir": "Upcoming",
  "v4.documents2.feuille.etat_en_cours": "In progress",
  "v4.documents2.feuille.etat_en_retard": "Late",
  "v4.documents2.feuille.etat_livre": "Delivered",
  "v4.documents2.feuille.etat_non_date": "Undated",
  "v4.documents2.feuille.etat_termine": "Done, not delivered",
  "v4.documents2.feuille.frise": "Product timeline",
  "v4.documents2.feuille.legende": "Legend: delivered, done not delivered, in progress, upcoming, late, undated.",
  "v4.documents2.feuille.ouvrir_entree": "Open input {{reference}}",
  "v4.documents2.feuille.planifier": "Plan cadences",
  "v4.documents2.feuille.reperes": "Milestones",
  "v4.documents2.feuille.reperes_indisponibles": "Milestones will show once the roadmap is read again.",
  "v4.documents2.feuille.titre": "Product roadmap",
  "v4.documents2.feuille.toutes_entrees": "All inputs",
  "v4.documents2.feuille.vide": "The roadmap is empty.",
  "v4.documents2.feuille.vide_filtre": "No item for this input.",
  "v4.documents2.feuille.vide_reperes": "No milestone defined by the model.",
  "v4.documents2.modele": "Frozen model: {{modele}}",
  "v4.documents2.modele_inconnu": "Project model unknown.",
  "v4.documents2.ouvrir_document": "Open “{{titre}}”",
  "v4.documents2.ouvrir_fiche": "Open the record",
  "v4.documents2.porte.acceptee": "Gate accepted.",
  "v4.documents2.porte.accepter": "Accept the gate",
  "v4.documents2.porte.aucune_decision": "No decision for this run.",
  "v4.documents2.porte.aucune_preuve": "No evidence required for this gate.",
  "v4.documents2.porte.conditions": "Conditions",
  "v4.documents2.porte.createur": "Run creator",
  "v4.documents2.porte.decision": "Decision",
  "v4.documents2.porte.decision_acceptee": "{{nom}} accepted step {{etape}}: {{motif}}",
  "v4.documents2.porte.decision_echec": "The decision failed.",
  "v4.documents2.porte.decision_refusee": "{{nom}} rejected on {{le}}: {{motif}}",
  "v4.documents2.porte.echec": "The action failed.",
  "v4.documents2.porte.etat": "Status",
  "v4.documents2.porte.execution": "Run of step {{etape}}",
  "v4.documents2.porte.historique": "Decision history",
  "v4.documents2.porte.hors_projet": "This gate does not belong to the open project: no decision is possible from this project.",
  "v4.documents2.porte.motif": "Decision reason",
  "v4.documents2.porte.motif_obligatoire": "The reason is required.",
  "v4.documents2.porte.preparee": "Run started.",
  "v4.documents2.porte.preparer": "Prepare the gate",
  "v4.documents2.porte.preuves": "Required evidence",
  "v4.documents2.porte.preuves_actuelles": "Current ({{n}})",
  "v4.documents2.porte.preuves_execution": "Run evidence",
  "v4.documents2.porte.preuves_manquantes": "Missing ({{n}})",
  "v4.documents2.porte.preuves_perimees": "Stale ({{n}})",
  "v4.documents2.porte.preuves_relues": "I have reviewed this run’s evidence",
  "v4.documents2.porte.quoi": "the gate",
  "v4.documents2.porte.refus_distinct": "A rejection is logged as an event distinct from a withdrawal.",
  "v4.documents2.porte.refusee": "Gate rejected.",
  "v4.documents2.porte.refuser": "Reject the gate",
  "v4.documents2.porte.reprendre": "Resume the run",
  "v4.documents2.porte.reprise": "Run resumed.",
  "v4.documents2.porte.retour": "Back to gates",
  "v4.documents2.porte.run": "Run {{run}}: {{etat}}",
  "v4.documents2.porte.run_echec": "failed",
  "v4.documents2.porte.run_en_attente_de_decision": "awaiting decision",
  "v4.documents2.porte.run_en_cours": "in progress",
  "v4.documents2.porte.run_terminee": "finished",
  "v4.documents2.porte.titre": "Phase gate",
  "v4.documents2.porte.version": "Frozen version",
  "v4.documents2.portes.aucune": "No gate planned by this model.",
  "v4.documents2.portes.conditions": "Conditions: {{conditions}}",
  "v4.documents2.portes.etat_a_preparer": "To prepare",
  "v4.documents2.portes.etat_acceptee": "Accepted",
  "v4.documents2.portes.etat_non_atteinte": "Not reached",
  "v4.documents2.portes.etat_prete_a_decider": "Ready to decide",
  "v4.documents2.portes.etat_refusee": "Rejected",
  "v4.documents2.portes.filtre": "Gate status",
  "v4.documents2.portes.filtre_a_decider": "To decide",
  "v4.documents2.portes.filtre_a_preparer": "To prepare",
  "v4.documents2.portes.filtre_terminees": "Closed",
  "v4.documents2.portes.filtre_toutes": "All",
  "v4.documents2.portes.methode": "Project method",
  "v4.documents2.portes.modele": "Template {{modele}}, version {{version}}",
  "v4.documents2.portes.nombre": "{{n}} gate(s) planned",
  "v4.documents2.portes.preuves_manquantes": "Missing evidence",
  "v4.documents2.portes.titre": "Phase gates",
  "v4.documents2.preuve.fraiche": "Fresh evidence",
  "v4.documents2.preuve.perimee": "Stale evidence",
  "v4.documents2.preuve.sans": "No evidence",
  "v4.documents2.publies.a_publier": "Documents to publish",
  "v4.documents2.publies.colonne_code": "Code reference",
  "v4.documents2.publies.colonne_document": "Document",
  "v4.documents2.publies.colonne_empreinte": "Output fingerprint",
  "v4.documents2.publies.colonne_publication": "Publication reference",
  "v4.documents2.publies.colonne_type": "Type",
  "v4.documents2.publies.colonne_version": "Version",
  "v4.documents2.publies.croissant": "Ascending",
  "v4.documents2.publies.decisions": "Pending decisions",
  "v4.documents2.publies.decroissant": "Descending",
  "v4.documents2.publies.derniere_version": "Latest version",
  "v4.documents2.publies.incomplete": "Incomplete publication: a reference is missing.",
  "v4.documents2.publies.sens": "Order",
  "v4.documents2.publies.titre": "Published documents",
  "v4.documents2.publies.tous_types": "All types",
  "v4.documents2.publies.toutes_versions": "All versions",
  "v4.documents2.publies.tri_document": "Document",
  "v4.documents2.publies.tri_element_source": "Source item",
  "v4.documents2.publies.tri_empreinte": "Fingerprint",
  "v4.documents2.publies.tri_reference_code": "Code reference",
  "v4.documents2.publies.tri_reference_publication": "Publication reference",
  "v4.documents2.publies.trier": "Sort by",
  "v4.documents2.publies.type": "Document type",
  "v4.documents2.publies.versions": "Versions",
  "v4.documents2.publies.vide": "No published document in this project.",
  "v4.documents2.raison.createur_n_approuve_pas": "The author does not decide on their own request.",
  "v4.documents2.raison.ia_arretee": "AI is stopped: retry once it is restored.",
  "v4.documents2.raison.validation_par_un_tiers": "Another person must validate.",
  "v4.documents2.redaction.approbateur": "Approved by {{nom}}",
  "v4.documents2.redaction.aucune_production": "No document production in this model.",
  "v4.documents2.redaction.aucune_revision_filtre": "No revision matches this filter.",
  "v4.documents2.redaction.decisions": "Decisions to make",
  "v4.documents2.redaction.deposer_entree": "Submit an input",
  "v4.documents2.redaction.documents": "Documents",
  "v4.documents2.redaction.entrees": "Project inputs",
  "v4.documents2.redaction.filtre_preuve": "Evidence",
  "v4.documents2.redaction.filtre_preuve_perimee": "Stale evidence",
  "v4.documents2.redaction.filtre_revision": "Revision status",
  "v4.documents2.redaction.filtre_sans_preuve": "No evidence",
  "v4.documents2.redaction.filtre_toutes": "All",
  "v4.documents2.redaction.liste_documents": "Project documents",
  "v4.documents2.redaction.onglet_documents": "Documents",
  "v4.documents2.redaction.onglet_revisions": "Revisions",
  "v4.documents2.redaction.onglets": "Writing",
  "v4.documents2.redaction.origine": "Origin: {{origine}}",
  "v4.documents2.redaction.points_bloquants": "{{n}} unverified blocking point(s)",
  "v4.documents2.redaction.rediger": "Write a document",
  "v4.documents2.redaction.revisions": "Revisions",
  "v4.documents2.redaction.titre": "Writing and revisions",
  "v4.documents2.redaction.vide_documents": "No document in this project.",
  "v4.documents2.redaction.vide_revisions": "No revision in this project.",
  "v4.documents2.rediger.amont": "Approved upstream documents",
  "v4.documents2.rediger.approbation": "Approval",
  "v4.documents2.rediger.approbation_absente": "No approval found for this version.",
  "v4.documents2.rediger.approuvee_par": "Approved by {{nom}} (decision {{id}})",
  "v4.documents2.rediger.choisir_amont": "Upstream document",
  "v4.documents2.rediger.choisir_production": "Choose a production",
  "v4.documents2.rediger.choisir_source": "Choose a source",
  "v4.documents2.rediger.consignes": "Instructions (optional)",
  "v4.documents2.rediger.consignes_non_transmises": "Assisted specification takes no instructions: choose another production to send some.",
  "v4.documents2.rediger.creation_initiale": "Creates a new document: no target document needed, distinct from a revision.",
  "v4.documents2.rediger.decisions_en_chargement": "Reading approvals.",
  "v4.documents2.rediger.decisions_indisponibles": "The project's approvals could not be read: try again.",
  "v4.documents2.rediger.document_amont_non_approuve": "The chosen version is not approved.",
  "v4.documents2.rediger.echec": "The request failed.",
  "v4.documents2.rediger.empreinte": "Fingerprint",
  "v4.documents2.rediger.lancee": "Writing started.",
  "v4.documents2.rediger.lancer_production": "Start the production",
  "v4.documents2.rediger.option_amont": "{{titre}} — version {{n}}",
  "v4.documents2.rediger.preparer_amont": "Prepare an upstream document",
  "v4.documents2.rediger.production": "Production to write",
  "v4.documents2.rediger.production_lancee": "Production started.",
  "v4.documents2.rediger.provenance": "Provenance",
  "v4.documents2.rediger.rediger_specification": "Write the specification",
  "v4.documents2.rediger.selection_amont_requise": "Choose an upstream document first.",
  "v4.documents2.rediger.source": "Production source",
  "v4.documents2.rediger.source_requise": "Choose an approved source.",
  "v4.documents2.rediger.sources_admissibles": "Eligible sources: approved project versions.",
  "v4.documents2.rediger.suivre": "Follow in decisions",
  "v4.documents2.rediger.titre": "Write a first document",
  "v4.documents2.rediger.titre_amont": "Title",
  "v4.documents2.rediger.version_amont": "Version",
  "v4.documents2.rediger.vide_amont": "No approved upstream document in this project.",
  "v4.documents2.repere.atteint": "Reached",
  "v4.documents2.repere.avancement": "Progress",
  "v4.documents2.repere.avancement_element": "Progress: {{avancement}}",
  "v4.documents2.repere.classement": "Project classification",
  "v4.documents2.repere.date_cible": "Target date",
  "v4.documents2.repere.elements": "Contributing items",
  "v4.documents2.repere.en_cours": "In progress",
  "v4.documents2.repere.en_retard": "Late",
  "v4.documents2.repere.preuves": "Evidence: {{n}}",
  "v4.documents2.repere.quoi": "the milestone",
  "v4.documents2.repere.retour": "Back to the roadmap",
  "v4.documents2.repere.sans_version": "No linked version",
  "v4.documents2.repere.situation": "Status",
  "v4.documents2.repere.source": "Milestone “{{cle}}” defined by the frozen model planning.",
  "v4.documents2.repere.titre": "Roadmap milestone",
  "v4.documents2.repere.version": "Version {{version}}",
  "v4.documents2.repere.vide_elements": "No item contributes to this milestone.",
  "v4.documents2.revision.acceptee": "Revision accepted.",
  "v4.documents2.revision.accepter": "Accept the revision",
  "v4.documents2.revision.cas": "Linked test cases: {{n}}",
  "v4.documents2.revision.confirmer_retrait": "I confirm withdrawing my revision",
  "v4.documents2.revision.criteres": "Criteria affected: {{n}}",
  "v4.documents2.revision.decideur": "Decided by",
  "v4.documents2.revision.decision": "Decision",
  "v4.documents2.revision.decision_echec": "The decision failed.",
  "v4.documents2.revision.deja_decidee": "This revision is already decided.",
  "v4.documents2.revision.demandeur": "Requester",
  "v4.documents2.revision.document_vise": "Open the target document",
  "v4.documents2.revision.elements": "Derived items: {{n}}",
  "v4.documents2.revision.etat": "Status",
  "v4.documents2.revision.etat_acceptee": "Accepted",
  "v4.documents2.revision.etat_ouverte": "Open",
  "v4.documents2.revision.etat_realisee": "Fulfilled",
  "v4.documents2.revision.etat_refusee": "Rejected",
  "v4.documents2.revision.etat_retiree": "Withdrawn",
  "v4.documents2.revision.etat_toutes": "All",
  "v4.documents2.revision.impact_calcule": "Computed impact",
  "v4.documents2.revision.impact_estime": "Estimated impact",
  "v4.documents2.revision.impact_incomplet": "Incomplete impact: some links could not be read.",
  "v4.documents2.revision.impact_major": "Major",
  "v4.documents2.revision.impact_minor": "Minor",
  "v4.documents2.revision.justification": "Justification",
  "v4.documents2.revision.note": "Decision note",
  "v4.documents2.revision.note_aide": "Required to reject.",
  "v4.documents2.revision.note_obligatoire": "A note is required to reject.",
  "v4.documents2.revision.quoi": "the revision",
  "v4.documents2.revision.refusee": "Revision rejected.",
  "v4.documents2.revision.refuser": "Reject the revision",
  "v4.documents2.revision.retiree": "Revision withdrawn.",
  "v4.documents2.revision.retirer": "Withdraw the revision",
  "v4.documents2.revision.retour": "Back to writing",
  "v4.documents2.revision.retrait_distinct": "Withdrawal by the requester and rejection by a validator are distinct events.",
  "v4.documents2.revision.retrait_echec": "The withdrawal failed.",
  "v4.documents2.revision.titre": "Revision proposal",
  "v4.documents2.revision.version_visee": "Target version",
  "v4.documents2.revision.versions_attente": "Pending versions: {{n}}",
  "v4.documents2.sans_projet": "Choose a project first.",
  "v4.documents2.version": "version {{n}}"
}
